module.exports = __webpack_public_path__ + "files/a1395ab5547262b469ad8a1d313ca677.png";